import { url } from '@/plugins/utils/game-name.js';

export class markSates { 
  static allSix (value) { //高低频六合彩
    const state = [1, 9, 14, 15, 16, 18, 23, 24, 29]
    return state.some(it => it == value)
  }
  static onlySix (value) { //低頻六合彩
    const state = [1, 14, 15]
    return state.some(it => it == value)
  }
  static onlySyssix (value) { //高频六合彩
    const state = [9, 16, 18, 23, 24, 29]
    return state.some(it => it == value)
  }
	static sixApiUrl (apiUrl, data) { //api重组
    const sixurl = markSates.onlySix(data.gameid) ? 'six' : url[data.gameid].url
		if(markSates.onlySyssix(data.gameid)) delete data.gameid
		const values = Object.values(data)
		return `${sixurl}/${apiUrl}/${values.join('/')}`
	}
  static highGuancai (value) { //高频官方彩源
		const state = [2, 3, 4, 5, 6, 8, 17]
		return state.some(it => it == value)
  }
  static onlyRacing (value) { // 赛车系列
    const state = [2, 11, 20, 26, 31]
    return state.some(it => it == value)
  }
  static onlyFt (value) { // 飞艇系列
    const state = [5, 12, 21, 27, 32]
    return state.some(it => it == value)
  }
  static onlyNc (value) { // 农场.广东（6）系列
    const state = [4, 6, 13, 22, 28, 33]
    return state.some(it => it == value)
  }
  static onlySsc (value) { // 时时彩.重庆系列
    const state = [3, 10, 19]
    return state.some(it => it == value)
  }
  static onlyFfc (value) { // 分分彩系列
    const state = [17, 25, 30]
    return state.some(it => it == value)
  }
}